import React from 'react';
import Model from './model';
import View from './view';

export default function(props) {
    return <Model>{prop => <View {...props} {...prop} />}</Model>;
}
